module.exports = __webpack_public_path__ + "static/media/google-desktop.57e7eee8.PNG";